var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9409_17405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9409_17405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29.5635C0.941176 29.5635 2.35294 27.587 4 27.3047C4.94118 27.3047 5.64706 29.2812 8 29.5635C9.64706 29.5635 10.3529 27.587 12 27.587C13.6471 27.587 14.3529 29.5635 16 29.5635C17.6471 29.5635 18.3529 27.587 20 27.587C21.6471 27.587 22.3529 29.5635 24 29.5635C25.6471 29.5635 26.3529 27.587 28 27.587C29.6471 27.587 30.3529 29.5635 32 29.5635",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21827 27.5994L2.14062 25.5382L29.9053 23.75C27.7218 25.7359 24.9171 27.3453 22.0794 28.6629",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1953 6.33594C17.92 7.78064 24.5271 14.7595 26.7765 22.2606C25.5435 21.7759 24.6212 21.2818 22.8894 21.7242C21.2141 15.6301 18.2165 9.80888 13.1953 6.33594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40982 3C10.4616 5.58824 18.7628 12.7929 20.2875 22.3882C13.3086 19.5741 7.9957 21.0753 4.29688 23.3576C9.93923 16.1859 7.40746 8.03059 4.40982 3Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo11);
export default __webpack_public_path__ + "static/media/logo11.319c31f7b761a6fcff2e54ca347c3b67.svg";
export { ForwardRef as ReactComponent };